<template>
    <div>
        <el-form :rules="rules" ref="ruleForm" label-width="110px" size="mini">
            <el-form-item prop="khid"  :label="$t('form_warehouse')" :rules="{required: true, message: '请选择仓库', trigger: 'blur'}">
                <el-select
                        size="mini"
                        style="margin-left: 0px;position: relative"
                        @change="ckchange"
                        class="input-width"
                        :disabled="ckHide"
                        v-model="i_ckid"
                        filterable>
                    <el-option
                            v-for="item in ckdata"
                            :key="item.i_id"
                            :label="item.vc_name"
                            :value="item.i_id">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item prop="name" label="装卸分类" :rules="{required: true, message: '请输装卸分类名称', trigger: 'blur'}">
                <div style="margin-left: 0px;position: relative">
                    <el-input  class="input-width" label="123" placeholder="请输入"  clearable v-model="vc_name" :disabled="isHide"></el-input>
                </div>
            </el-form-item>
            <!--<el-form-item prop="mj" class="lable-width" label="面积(m²)" >
                <div style="margin-left: 0px;position: relative">
                    <el-input class="input-width" label="123" placeholder="请输入面积"  clearable v-model="editData.mj" :disabled="isHide"></el-input>
                </div>
            </el-form-item>-->

           <!-- <el-form-item prop="rl" class="lable-width" label="容量(t)">
                <div style="margin-left: 0px;position: relative">
                    <el-input  class="input-width" label="123" placeholder="请输入"  disabled clearable v-model="editData.rl"></el-input>
                </div>
            </el-form-item>-->

            <!--<el-form-item prop="createime" class="lable-width" label="发布时间">
                <div style="margin-left: 0px;position: relative">
                    <el-input  class="input-width" label="123" disabled  clearable v-model="editData.createTime"></el-input>
                </div>
            </el-form-item>-->

            <!--<el-form-item prop="lruName" class="lable-width" label="录入人姓名">
                <div style="margin-left: 0px;position: relative">
                    <el-input  class="input-width" label="123" disabled  clearable v-model="editData.lruName"></el-input>
                </div>
            </el-form-item>-->
            <el-form-item  label="产品类型">
                    <el-radio v-model="i_type" :label="0">全部</el-radio>
                    <el-radio v-model="i_type" :label="1">散水</el-radio>
                    <el-radio v-model="i_type" :label="2">非散水</el-radio>
            </el-form-item>
            <el-form-item  label="是否启用">
                <div>
                    <el-radio v-model="i_state" :label="1">启用</el-radio>
                    <el-radio v-model="i_state" :label="0">不启用</el-radio>
                </div>
            </el-form-item>
            <el-form-item  label="录入人">
                <span>{{lruName}}</span>
            </el-form-item>
            <el-form-item  label="录入时间">
                <span>{{dt_createtime}}</span>
            </el-form-item>
            <el-form-item prop="note"  :label="$t('form_notes')">
                <div style="margin-left: 0px;position: relative">
                    <el-input  class="input-width" label="123" placeholder="请输入"  clearable v-model="vc_note" :disabled="isHide"></el-input>
                </div>
            </el-form-item>
            <el-form-item class="lable-width" style="margin-left: 0">
                <el-button  :class="baseerp+'btn'" type="primary" @click="onSubmit" :disabled="isDisable">保存</el-button>
                <el-button  :class="baseerp+'btn'" type="primary" @click="close">取消</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
    import * as API from "../api";
    import {mapActions} from "vuex";
    import {baseerp} from "@/utils/baseUrl";
    export default {
        name: 'reviseReservoirArea',
        props:{
            Data:{
                type:Object,
                required:true,
            },
        },
        data(){
            return{
                i_id:null,
                i_ckid:0,
                vc_name:'',
                i_state:1,
                i_type:0,
                vc_note:'',
                lruid:'',
                lruName:'',
                dt_createtime:"",
                baseerp:'',
                isDisable:false,
                timeStamp:'',
                validateKey:'',
                ckdata:[],
                editData:this.Data,
                isHide:false,
                //ckHide:true,
                ckHide:false,
                rules: {
                    mj: [
                        {required: true, message: '请输入面积', trigger: 'blur'},
                        // {pattern: /^-?\d+(\.\d+)?$/, message: "请输入合法面积", trigger: "blur" },
                        {pattern: /^[0-9]+\.{0,1}[0-9]{0,15}$/, message: "请输入大于0的数字", trigger: "blur" },
                        {pattern: /^\d+(\.\d{1,5})?$/, message: "请保留五位小数", trigger: "blur" }
                    ]

                }

            }
        },
        watch:{
            Data: {
                handler() {
                    if (!this.Data.i_id) {
                        //console.log("xinzeng")
                        this.lruid = sessionStorage.getItem("userid");
                        this.lruName = sessionStorage.getItem("lruname");
                        this.dt_createtime = this.getDateYYYYMMddHHMMSS();
                    } else {
                        //console.log("bianji")
                        this.i_id = this.Data.i_id;
                        this.vc_name = this.Data.vc_name;
                        this.i_ckid = this.Data.i_ckid;
                        this.vc_ckname = this.Data.vc_ckname;
                        this.i_state = this.Data.i_state;
                        this.vc_note = this.Data.vc_note;
                        this.lruid = this.Data.i_lruid;
                        this.lruName = this.Data.vc_lruname;
                        this.dt_createtime = this.Data.dt_createTime;
                        this.i_type = this.Data.i_type;
                    }
                },
                immediate: true,
                deep: true
            },
        },
        mounted(){
            this.baseerp=baseerp;
            this.selectWarehouse();
            /*if(!this.i_id){
                this.lruid=sessionStorage.getItem("userid");
                this.lruName=sessionStorage.getItem("lruname");
                this.dt_createtime = this.getDateYYYYMMddHHMMSS();
            }else{
                this.i_id=Data.i_id;
                this.vc_name=Data.vc_name;
                this.i_ckid=Data.i_ckid;
                this.i_state=Data.i_state;
                this.vc_note=Data.vc_note;
                this.lruid=Data.i_lruid;
                this.lruName=Data.vc_lruname;
                this.dt_createtime = Data.dt_createTime;
            }*/
        },
        methods:{
            ...mapActions(["getCurrentMenuId"]),
            getDateYYYYMMddHHMMSS(){
                const date = new Date();
                const month = (date.getMonth() + 1).toString().padStart(2, '0');
                const strDate = date.getDate().toString().padStart(2, '0');
                return `${date.getFullYear()}-${month}-${strDate}`;
            },
            ckchange(e){
                //console.log(e)
                this.i_ckid=e;
                let pick = this.ckdata.filter((item)=>{
                    return item.i_id == e
                })
                this.vc_ckname=pick[0].vc_name;
                //console.log(this.vc_ckname,pick)
                this.$forceUpdate()
            },
            close(){
                this.$emit('close')
            },
            onSubmit(){
                this.save()
            },

            //仓库下拉
            async selectWarehouse() {
                let result = await this.getCurrentMenuId({path: this.$route.path});
                if (result.i_id) {
                    this.mid = result.i_id
                    sessionStorage.setItem('mids', result.i_id)
                } else {
                    this.mid = sessionStorage.getItem('mids')
                }
                let params={
                    page_size:1,
                    page_count:999,
                }
                let res = await API.getWarehouseList(params);
                if (res.code == 1) {
                    this.ckdata = res.data;
                  /*  let arr =  res.data;
                    arr.forEach(item=>{
                        if(item.warehouseId==this.editData1.khid){
                            this.editData.khid=item.warehouseId
                        }
                    })*/
                    // this.editData.khid=arr[0].warehouseId
                    this.ckHide=false
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else {
                    this.$message.error(res.message);
                }
            },

            /*//库区详情
            async getDetails(val) {
                let result = await this.getCurrentMenuId({path: this.$route.path});
                if (result.i_id !== "") {
                    this.mid = result.i_id
                    sessionStorage.setItem('mids', result.i_id)
                } else {
                    this.mid = sessionStorage.getItem('mids')
                }
                let params = {
                    id:this.editData.id,
                }
                let res = await API.getDetails(params);
                if (res.code == 1) {
                    this.editData=res.data
                    // this.tableData.forEach(item=>{
                    //     item.createTime=item.createTime.substring(0,19)
                    // })
                    this.isHide=false
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else {
                    this.$message.error(res.message);
                }
            },*/

            //保存
            async save() {
                if(this.i_ckid==0){
                    this.$message({
                        message: '请选择仓库名称',
                        type: 'error'
                    });
                    return
                }
                if(this.vc_name==''){
                    this.$message({
                        message: '请输入装卸分类名称',
                        type: 'error'
                    });
                    return
                }
                let result = await this.getCurrentMenuId({path: this.$route.path});
                if (result.i_id !== "") {
                    this.mid = result.i_id
                    sessionStorage.setItem('mids', result.i_id)
                } else {
                    this.mid = sessionStorage.getItem('mids')
                }
                let params = {
                    i_id:this.i_id,
                    vc_name:this.vc_name,
                    i_ckid:this.i_ckid,
                    vc_ckname:this.vc_ckname,
                    i_state:this.i_state,
                    vc_note:this.vc_note,
                    i_type:this.i_type,
                }
                this.isDisable = true;
                //console.log("保存params",params);
                //return;
                let res = await API.saveZXType(params);
                if (res.code == 1) {
                    this.isDisable = false;
                    this.$emit("close");
                    this.$emit('getList');
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else {
                    this.isDisable = false;
                    this.$message.error(res.message);
                }
            },


        }
    }
</script>
<style lang="scss" scoped>
    /deep/{
        .lable-width .el-form-item__content{
            margin-left: 0 !important;
        }
        .el-textarea__inner{
            height: 100px !important;
            color: #000000 !important;
            /*font-weight: 600 !important;*/
            font-size: inherit !important;
        }
        .el-form-item__error{
            left: 50% !important;
        }
    }
    .lable-width{
        text-align: center;
    }
    .slable-width{

    }
    .dialog-footer{
        display: flex;
        justify-content: center;
        align-items: center;
        /*text-align: center;*/
        margin-top: 12px;
    }
    .input-width{
        /*text-align: center;*/
        width: 18.571rem;
    }
    .sinput-width{
        width: 150px;
        margin-left: 28px;
    }
    /deep/.json .el-textarea__inner{
        height: 180px !important;
    }
    /deep/.describe .el-textarea__inner{
        height: 80px !important;

    }
</style>